import { useEffect } from 'react';
import { TimeField, useFormField } from '../../forms';
import { Text } from '../../text';
import { TimeBarProps } from '../types';
import { useWeekViewDatePicker } from '../week-view-date-picker.provider';

export const TimeBar = ({
  endTimeLabel = 'End Time',
  maxTime,
  minTime,
  startTimeLabel = 'Start Time',
  timeInterval = 15,
}: TimeBarProps) => {
  const { activeValue, onChange, setHasTimeInput } = useWeekViewDatePicker();

  const startTimeFieldProps = useFormField(
    {
      type: 'time',
      value: activeValue.startTime,
    },
    [activeValue.startTime]
  );

  const endTimeFieldProps = useFormField(
    {
      type: 'time',
      value: activeValue.endTime,
    },
    [activeValue.endTime]
  );

  useEffect(() => {
    onChange({ ...activeValue, startTime: startTimeFieldProps.value, endTime: endTimeFieldProps.value });
  }, [startTimeFieldProps.value, endTimeFieldProps.value]);

  useEffect(() => {
    setHasTimeInput(true);
  }, []);

  return (
    <div className='time-bar'>
      <TimeField
        {...startTimeFieldProps}
        interval={timeInterval}
        label={startTimeLabel}
        maxTime={endTimeFieldProps.value || maxTime}
        minTime={minTime}
        name='startTime'
      />
      <Text>to</Text>
      <TimeField
        {...endTimeFieldProps}
        interval={timeInterval}
        label={endTimeLabel}
        maxTime={maxTime}
        minTime={startTimeFieldProps.value || minTime}
        name='endTime'
      />
    </div>
  );
};
